import {
  useState,
  useEffect,
  useReducer,
  Fragment,
  useRef,
  useContext,
} from "react";
import { axiosPut } from "@/services/axiosService";
import { useDispatch } from "react-redux";
import useStore from "@/pages/omni-builder/store";
import { userSlice } from "@/redux/User";
import * as MetaService from "@/services/facebook.service";
import BooleanModal from "../builder/BooleanModal";
import useWhatsAppConfig from "@/pages/omni-builder/react-query/configs/useWhatsAppConfig";
import { useQueryClient } from "@tanstack/react-query";
import { useSearchParams } from "react-router-dom";
import ModalWrapper from "@/pages/cbb-builder/components/ModalWrapper";
import {
  ConnectIcon,
  DisconnectIcon,
} from "@/pages/cbb-builder/components/Channels/components/WhatsappChannel";
import { AnimatePresence, motion } from "framer-motion";
import { ErrSvgIcon } from "./Instagram";
import { BotContext } from "@/pages/cbb-builder/store";

interface Props {
  onClose?: any;
  botCustomId?: any;
  liveBotId?: any;
  setOpenPopUp?: any;
  // fromBuilder?: any;
  // getHandoffConfigs?: any;
  onSelect?: any;
}

export default function WhatsappNew({
  onClose,
  botCustomId,
  liveBotId,
  setOpenPopUp,
}: Props) {
  const dispatch = useDispatch();
  const [store, storeDispatch] = useContext(BotContext);
  const [state, setState] = useState(0);
  const [phoneNumbers, setPhoneNumbers] = useState<any[]>([]);
  const [whatsappDisconnecting, setWhatsappDisconnecting] =
    useState<boolean>(false);
  const [disconnectingAccountId, setDisconnectingAccountId] = useState<
    string | null
  >(null);
  const setIsWhatsappLoading = useStore((state) => state.setIsWhatsappLoading);
  const queryClient = useQueryClient();
  const whatsappConfiguration = useWhatsAppConfig();
  const [fbReponse, setFbReponse] = useState<any>(null);
  const [connection, setConnection] = useState<any>(false);
  const [connectionStatus, setConnectionStatus] = useState({});
  const [isExist, setIsExist] = useState<any>({});
  const [searchParams] = useSearchParams();
  const [reload, fReload] = useReducer((state) => !state, false);
  const manualRef = useRef(false);
  const [replacingNumberId, setReplacingNumberId] = useState<string | null>(
    null,
  );
  const accounts = whatsappConfiguration.data?.accounts ?? [];
  const numberToReplace = phoneNumbers.find(
    (data) => data.connected && isExist[data._id],
  );

  useEffect(() => {
    if (whatsappConfiguration.isFetching) {
      setFbReponse(null);
      return;
    }

    if (whatsappConfiguration.isLoading || fbReponse) return;

    if (whatsappConfiguration.isError) {
      dispatch(
        userSlice.actions.setToastPopUp({
          show: true,
          toastType: "error",
          message: "Error while fetching whatsapp configuration",
        }),
      );
      return;
    }

    const config = whatsappConfiguration.data;

    // ✅ CASE: config is null AFTER manual connect
    if (!config) {
      if (manualRef.current) {
        // User clicked "Connect WhatsApp" but config is still null after window closes
        dispatch(
          userSlice.actions.setToastPopUp({
            show: true,
            toastType: "error",
            message:
              "Failed to fetch WhatsApp configuration after connect. Please try again.",
          }),
        );
        manualRef.current = false; // reset to avoid repeated toast
      } else {
        // Normal load – no config – initiate connection flow
        const connectMeta = async () => {
          try {
            const forcedLogin = searchParams.get("forced") === "true";
            const loginLink = await MetaService.whatsappLogin(forcedLogin);
            const authWindow = window.open(
              loginLink,
              "_blank",
              "width=600,height=600",
            );

            const checkClosed = setInterval(async () => {
              if (authWindow?.self?.closed || authWindow?.closed) {
                storeDispatch({
                  type: "set-isChannel",
                  isChannel: true,
                });
                manualRef.current = true;
                queryClient.invalidateQueries({
                  queryKey: ["configurations", "whatsapp"],
                });
                clearInterval(checkClosed);
                setOpenPopUp(false);
              }
            }, 1000);
          } catch (error: any) {
            if (error.cause === "suppress") return;
            dispatch(
              userSlice.actions.setToastPopUp({
                show: true,
                toastType: "error",
                message: error?.message || "Something went wrong",
              }),
            );
          }
        };

        if (!manualRef.current) connectMeta();
      }

      return;
    }

    // ✅ Success case
    setPhoneNumbers(config?.phoneNumbers ?? []);
    setState(1);
  }, [whatsappConfiguration, fbReponse]);

  // useEffect(() => {
  //   if (whatsappConfiguration.isFetching) {
  //     setFbReponse(null);
  //     return;
  //   }
  //   if (whatsappConfiguration.isLoading || fbReponse) return;
  //   if (whatsappConfiguration.isError) {
  //     dispatch(
  //       userSlice.actions.setToastPopUp({
  //         show: true,
  //         toastType: "error",
  //         // message: whatsappConfiguration.error.message,
  //         message: "Error while fetching whatsapp configuration",
  //       }),
  //     );
  //     // onClose();
  //     return;
  //   }

  //   let config = whatsappConfiguration.data;
  //   if (!config) {
  //     const connectMeta = async () => {
  //       try {
  //         const forcedLogin = searchParams.get("forced");
  //         const forced = forcedLogin === "true" ? true : false;
  //         const loginLink = await MetaService.whatsappLogin(forced);
  //         const authWindow = window.open(
  //           loginLink,
  //           "_blank",
  //           "width=600,height=600",
  //         );
  //         const checkClosed = setInterval(async () => {
  //           if (authWindow?.self?.closed) {
  //             console.log("closed", authWindow);
  //             storeDispatch({
  //               type: "set-isChannel",
  //               isChannel: true,
  //             });
  //             manualRef.current = true;
  //             queryClient.invalidateQueries({
  //               queryKey: ["configurations", "whatsapp"],
  //             });
  //             clearInterval(checkClosed);
  //           } else if (authWindow?.closed) {
  //             console.log("self closed");
  //             setOpenPopUp(false);
  //             authWindow?.close();
  //             clearInterval(checkClosed);
  //             // onClose();
  //           }
  //         }, 1000);
  //       } catch (error: any) {
  //         if (error.cause === "suppress") return;
  //         const errMsg = typeof error === "string" ? error : error.message;

  //         dispatch(
  //           userSlice.actions.setToastPopUp({
  //             show: true,
  //             toastType: "error",
  //             message: errMsg || "Something went wrong",
  //           }),
  //         );
  //         // onClose();
  //       }
  //     };
  //     if (!manualRef.current) connectMeta();
  //     return;
  //   }

  //   setPhoneNumbers(config?.phoneNumbers ?? []);
  //   setState(1);
  // }, [whatsappConfiguration, fbReponse]);

  const disconnectMeta = async (accountId?: string) => {
    try {
      setDisconnectingAccountId(accountId ?? "all");
      setWhatsappDisconnecting(false);
      const idQuery = accountId ? `&id=${accountId}` : "";
      await axiosPut(
        `/configurations/deleteAppConfig?siteName=whatsapp${idQuery}`,
      );
      const currentConfig: any = queryClient.getQueryData([
        "configurations",
        "whatsapp",
      ]);
      const remainingAccounts = (currentConfig?.accounts ?? []).filter(
        (account: any) => !accountId || account.id !== accountId,
      );
      queryClient.setQueryData(["configurations", "whatsapp"], {
        ...(currentConfig ?? {}),
        accounts: remainingAccounts,
        phoneNumbers: remainingAccounts.flatMap(
          (account: any) => account.phoneNumbers ?? [],
        ),
      });
      dispatch(
        userSlice.actions.setToastPopUp({
          show: true,
          toastType: "success",
          message: "Your Meta WhatsApp account disconnected successfully",
        }),
      );

      await MetaService.logout();
      setIsWhatsappLoading(false);
      queryClient.invalidateQueries({
        queryKey: ["configurations", "whatsapp"],
      });
      onClose?.();
    } catch (err) {
      console.log("error while disconnecting Account");
    } finally {
      setDisconnectingAccountId(null);
    }
  };

  const addWhatsappAccount = async () => {
    const loginLink = await MetaService.whatsappLogin(false);
    const authWindow = window.open(loginLink, "_blank", "width=600,height=600");
    const checkClosed = window.setInterval(() => {
      if (authWindow?.closed) {
        window.clearInterval(checkClosed);
        queryClient.invalidateQueries({
          queryKey: ["configurations", "whatsapp"],
        });
      }
    }, 1000);
  };

  const handleLink = async (data, type) => {
    try {
      if (!data?.nameStatus && type !== "disconnect") {
        return await _sendErrorToast(
          "Display name status not found. Please check your Meta account.",
        );
      }

      if (
        (!data?.phoneStatus || data?.phoneStatus !== "CONNECTED") &&
        type !== "disconnect"
      ) {
        return await _sendErrorToast(
          "Your phone number is not connected. Please connect it in Meta account.",
        );
      }

      if (data?.nameStatus === "DECLINED" && type !== "disconnect") {
        return await _sendErrorToast(
          "Your display name request was rejected. Please resubmit for approval.",
        );
      }

      if (
        (data?.nameStatus === "AVAILABLE_WITHOUT_REVIEW" ||
          data?.nameStatus === "NON_EXISTS") &&
        type !== "disconnect"
      ) {
        return await _sendErrorToast(
          "Your display name has not been reviewed yet. Please wait for Meta approval.",
        );
      }

      if (!liveBotId || liveBotId === undefined || liveBotId === "undefined")
        return await _sendErrorToast("Agent is not live yet!");
      setConnection(true);
      if (type === "replace") {
        setReplacingNumberId(data._id);
      }

      setConnectionStatus((prev) => ({ ...prev, [data._id]: type }));
      let isChanged = false;

      if (type === "connect") {
        console.log(phoneNumbers);
        const shouldUpdateState = phoneNumbers?.some(
          (item) =>
            item._id === data._id &&
            data.botCustomId &&
            data.botCustomId !== botCustomId,
        );

        if (shouldUpdateState) {
          isChanged = true;
          setIsExist((prev) => ({
            ...prev,
            [data._id]: true,
          }));
        }
      }

      if (isChanged) return;

      const res = await axiosPut(
        `/configurations/${type === "disconnect" ? "disconnectAcccount" : "connectAcccount"}`,
        {
          siteName: "whatsapp",
          _id: data._id,
          botId: liveBotId,
          botCustomId,
        },
      );

      if (res.data?.message === "Data is updated successfully") {
        fReload();
        const actionText =
          type === "replace"
            ? "replaced"
            : type === "disconnect"
              ? "disconnected"
              : "connected";
        await _sendSuccessToast(
          `Your Whatsapp number ${actionText} successfully`,
        );
        queryClient.invalidateQueries({
          queryKey: ["configurations", "whatsapp"],
        });
      } else {
        dispatch(
          userSlice.actions.setToastPopUp({
            show: true,
            toastType: "error",
            message: res.data?.message,
          }),
        );
      }
      if (type === "replace") {
        setIsExist((prev) => ({
          ...prev,
          [data._id]: false,
        }));
      }
      onClose();
    } catch (err) {
      console.log(err);
      await _sendErrorToast(
        "Failed to process the request. Please check your connection or try again.",
      );
      if (type === "replace") {
        setIsExist((prev) => ({
          ...prev,
          [data._id]: false,
        }));
      }
      onClose();
    } finally {
      setConnection(false);
      setConnectionStatus((prev) => ({ ...prev, [data._id]: false }));
      if (type === "replace") {
        setReplacingNumberId(null);
      }
    }
  };

  async function _sendErrorToast(err?: any) {
    dispatch(
      userSlice.actions.setToastPopUp({
        show: true,
        toastType: "error",
        message: !!err
          ? typeof err === "string"
            ? err
            : typeof err?.response?.data?.message === "string"
              ? err?.response?.data?.message
              : "Something went wrong"
          : "Something went wrong",
      }),
    );
  }

  async function _sendSuccessToast(msg?: any) {
    dispatch(
      userSlice.actions.setToastPopUp({
        show: true,
        toastType: "success",
        message: msg,
      }),
    );
  }
  if (whatsappConfiguration.isLoading || whatsappConfiguration.isFetching) {
    return (
      <div className="flex min-h-[180px] items-center justify-center">
        <span className="h-[28px] w-[28px] animate-spin rounded-full border-4 border-[#d5f6dc] border-t-[#16833b]" />
        <span className="ml-[10px] text-[14px] text-[#666]">
          Loading WhatsApp accounts...
        </span>
      </div>
    );
  }
  if (!state) return null;

  return (
    <>
      {accounts.length > 0 && (
        <div className="mt-[10px]">
          <div className="mb-[14px] flex items-center justify-between">
            <h4 className="text-[16px] font-medium text-text-clr">
              Connected WhatsApp Accounts
            </h4>
            <button
              onClick={addWhatsappAccount}
              className="rounded-[6px] border border-primary-clr px-[14px] py-[8px] text-[14px] text-primary-clr"
            >
              + Add account
            </button>
          </div>
          <div className="flex flex-col gap-[14px]">
            {accounts.map((account: any, accountIndex: number) => (
              <div
                key={account.id ?? account.wabaId ?? accountIndex}
                className="rounded-[16px] border border-[rgba(0,0,0,0.1)] bg-white p-[18px]"
              >
                <div className="mb-[14px] flex items-center justify-between">
                  <div className="flex items-center gap-[10px]">
                    {/* HIDE FOR NOW... */}
                    {/* <img
                      src={account.picture}
                      alt=""
                      className="h-[34px] w-[34px] rounded-full"
                    />  */}
                    <div>
                      <p className="text-[16px] font-medium">
                        {account.accountName ||
                          `WhatsApp Business Account ${accountIndex + 1}`}
                      </p>
                      {/* <p className="text-[12px] text-[#777]">
                        Business ID: {account.wabaId || "—"}
                      </p> */}
                    </div>
                  </div>
                  <button
                    onClick={() => disconnectMeta(account.id)}
                    disabled={!!disconnectingAccountId}
                    className="rounded-[6px] border border-[#f5a5a5] px-[12px] py-[7px] text-[13px] text-[#d84b4b] disabled:opacity-60"
                  >
                    {disconnectingAccountId === account.id
                      ? "Logging out..."
                      : "Logout"}
                  </button>
                </div>
                <div className="overflow-x-auto rounded-[10px] border border-[rgba(0,0,0,0.08)]">
                  <table className="w-full min-w-[600px] text-left text-[14px] [&_td]:!table-cell [&_td]:align-middle [&_th]:!table-cell [&_th]:align-middle">
                    <thead className="bg-[#fafafa] text-[#666]">
                      <tr>
                        <th className="px-[14px] py-[11px]">Phone Name</th>
                        <th className="px-[14px] py-[11px]">Phone Number</th>
                        <th className="px-[14px] py-[11px]">Status</th>
                        <th className="px-[14px] py-[11px] text-right">
                          Action
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      {(account.phoneNumbers ?? []).map((data: any) => (
                        <tr
                          key={data._id ?? data.phoneId}
                          className="border-t border-[rgba(0,0,0,0.06)]"
                        >
                          <td className="px-[14px] py-[12px]">
                            <div className="flex flex-wrap items-center gap-[8px]">
                              <span>{data.name || "—"}</span>
                              {data.nameStatus === "DECLINED" ? (
                                <span className="rounded-[5px] bg-[#3395dd] px-[6px] py-[4px] text-[12px] leading-[100%] text-white">
                                  Rejected
                                </span>
                              ) : data.nameStatus ===
                                  "AVAILABLE_WITHOUT_REVIEW" ||
                                data.nameStatus === "NON_EXISTS" ? (
                                <span className="rounded-[5px] bg-[#f39c12] px-[6px] py-[4px] text-[12px] leading-[100%] text-white">
                                  Not Verified
                                </span>
                              ) : (
                                <span className="rounded-[5px] bg-[#3395dd] px-[6px] py-[4px] text-[12px] leading-[100%] text-white">
                                  Verified
                                </span>
                              )}
                            </div>
                          </td>
                          <td className="px-[14px] py-[12px]">
                            {data.display_phone_number || data.phoneId}
                          </td>
                          <td className="px-[14px] py-[12px]">
                            <span
                              className={`rounded-full px-[9px] py-[4px] text-[12px] ${data.phoneStatus === "CONNECTED" ? "bg-[#d5f6dc] text-[#16833b]" : "bg-[#ffe7e6] text-[#b74747]"}`}
                            >
                              {data.phoneStatus === "CONNECTED"
                                ? "Active"
                                : data.phoneStatus || "Not connected"}
                            </span>
                          </td>
                          <td className="px-[14px] py-[12px] text-right">
                            <button
                              onClick={() =>
                                handleLink(
                                  data,
                                  data.connected &&
                                    data.botCustomId === botCustomId
                                    ? "disconnect"
                                    : "connect",
                                )
                              }
                              disabled={!!connectionStatus[data._id]}
                              className="rounded-[6px] border border-[#9bd6b1] px-[14px] py-[7px] text-[#16833b]"
                            >
                              {connectionStatus[data._id]
                                ? connectionStatus[data._id] === "connect"
                                  ? "Connecting..."
                                  : connectionStatus[data._id] === "disconnect"
                                    ? "Disconnecting..."
                                    : "Replacing..."
                                : data.connected &&
                                    data.botCustomId === botCustomId
                                  ? "Disconnect"
                                  : "Connect"}
                            </button>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>
            ))}
          </div>
        </div>
      )}
      {numberToReplace && (
        <ModalWrapper>
          <BooleanModal
            resetCharacterCountOnConfirm={false}
            onConfirm={() => handleLink(numberToReplace, "replace")}
            onCancel={() =>
              setIsExist((prev) => ({
                ...prev,
                [numberToReplace._id]: false,
              }))
            }
            content={{
              title: "Replace Agent",
              message:
                "This number is already connected to another agent. Do you want to replace the earlier agent with the current agent?",
            }}
            buttons={{ confirm: "Replace Agent", cancel: "Cancel" }}
          />
        </ModalWrapper>
      )}

      {whatsappDisconnecting ? (
        <ModalWrapper>
          <BooleanModal
            onConfirm={() => disconnectMeta()}
            onCancel={() => setWhatsappDisconnecting(false)}
            content={{
              title: "Logout of WhatsApp",
              message: `Logging out will stop all active workflows running on WhatsApp. \n Are you sure you want to continue?`,
            }}
            buttons={{
              confirm: "Logout",
              cancel: "Cancel",
            }}
          />
        </ModalWrapper>
      ) : null}
    </>
  );
}
